import { FC } from 'react'
import './LandingHero.scss'
import { LandingHeroActions } from './LandingHeroActions'

export const LandingHero: FC = () => {
  return (
    <div className="LandingHero">
      <div className="tip">The best tool to</div>

      <h1 className="title">Cut audio online</h1>

      <div className="description">
        Select an audio file you want to cut by clicking on the first button below, or you can get acquainted with the
        software using the prepared test file. Please let us know how much you enjoyed using our tool or suggest
        possible improvements.
      </div>

      <div className="buttons">
        <LandingHeroActions />
      </div>

      <div className="description">It's private, your audio file will not be saved anywhere but your browser.</div>
    </div>
  )
}
